import { render, staticRenderFns } from "./group-withdrawal.vue?vue&type=template&id=1fd4a51f&scoped=true"
import script from "./group-withdrawal.vue?vue&type=script&lang=js"
export * from "./group-withdrawal.vue?vue&type=script&lang=js"
import style0 from "./group-withdrawal.vue?vue&type=style&index=0&id=1fd4a51f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd4a51f",
  null
  
)

export default component.exports